module.exports = __webpack_public_path__ + "img/IMG_1962_P_L_Foamcore_MockedUp.afc11f24.jpg";